import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTargetRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.078 8A5.078 5.078 0 1 0 2.922 8a5.078 5.078 0 0 0 10.156 0M1.75 8a6.25 6.25 0 1 1 12.5 0 6.25 6.25 0 0 1-12.5 0M8 10.344a2.344 2.344 0 1 0 0-4.688 2.344 2.344 0 0 0 0 4.688m0-5.86a3.516 3.516 0 1 1 0 7.031 3.516 3.516 0 0 1 0-7.03M7.219 8A.781.781 0 1 1 8.78 8a.781.781 0 0 1-1.56 0" })
});
export default SvgTargetRegularIcon;
